import { callEndpoint, streamEndpoint } from './runtime';
export { callEndpoint, streamEndpoint } from './runtime';
export type AiRoomLayoutOutputType = any;
export type CheckAgeEstimatesOutputType = any;
export type CheckLeaveConflictsOutputType = any;
export type GenerateMiniQuizOutputType = any;
export type GenerateQuizQuestionsOutputType = any;
export type GenerateSafeAndLegalQuizOutputType = any;
export type GetAdminAttensiOutputType = any;
export type GetAdminComplianceFormsOutputType = any;
export type GetAdminCoursePreviewOutputType = any;
export type GetAdminDashboardOutputType = any;
export type GetAdminEditRequestsOutputType = any;
export type GetAdminEmployeeProgressOutputType = any;
export type GetAdminEmployeesOutputType = any;
export type GetAdminEnrollmentsOutputType = any;
export type GetAdminHandbookOutputType = any;
export type GetAdminModulesOutputType = any;
export type GetAdminPoliciesOutputType = any;
export type GetAdminQuestionsOutputType = any;
export type GetAdminReportsOutputType = any;
export type GetAdminRewardsDataOutputType = any;
export type GetAdminTrainingRequestsOutputType = any;
export type GetAdminUniformsOutputType = any;
export type GetAdminVenueDataOutputType = any;
export type GetAnnouncementsOutputType = any;
export type GetAssessmentQueueOutputType = any;
export type GetAssessmentSessionOutputType = any;
export type GetAuditReadinessOutputType = any;
export type GetAvailabilityOutputType = any;
export type GetBmsEventsOutputType = any;
export type GetBridgeFeedAuditOutputType = any;
export type GetBridgeHealthOutputType = any;
export type GetCertificatesOutputType = any;
export type GetChecklistTemplatesOutputType = any;
export type GetComplianceCertsOutputType = any;
export type GetComplianceDataOutputType = any;
export type GetComplianceExpiryOutputType = any;
export type GetComplianceQuizOutputType = any;
export type GetCoshhDataOutputType = any;
export type GetCourseBuilderModulesOutputType = any;
export type GetCourseCompletionOutputType = any;
export type GetCourseDetailOutputType = any;
export type GetCourseModuleDetailOutputType = any;
export type GetCourseQuizQuestionsOutputType = any;
export type GetCustomerContactsOutputType = any;
export type GetDailyOpsBridgeOutputType = any;
export type GetDataQualityOutputType = any;
export type GetDocumentAccessLogsOutputType = any;
export type GetDocumentLibraryOutputType = any;
export type GetDocumentsOutputType = any;
export type GetDuplicateStaffOutputType = any;
export type GetEmployeeDashboardOutputType = any;
export type GetEmployeeOfMonthOutputType = any;
export type GetEngagementInsightsOutputType = any;
export type GetEventsOutputType = any;
export type GetFeatureTogglesOutputType = any;
export type GetFeedbackCentreOutputType = any;
export type GetFireLogOutputType = any;
export type GetHandbookOutputType = any;
export type GetHealthSafetyDataOutputType = any;
export type GetImportQueueOutputType = any;
export type GetImportReportOutputType = any;
export type GetInfoHubOutputType = any;
export type GetJournalOutputType = any;
export type GetKeyManagementOutputType = any;
export type GetKnowledgeBaseOutputType = any;
export type GetLabourOverviewOutputType = any;
export type GetLeaveRequestsOutputType = any;
export type GetMaintenanceTasksOutputType = any;
export type GetManagerDashboardOutputType = any;
export type GetManagerOpsOutputType = any;
export type GetManagerReviewsOutputType = any;
export type GetManagerTasksOutputType = any;
export type GetManagerTriageOutputType = any;
export type GetMessagesOutputType = any;
export type GetModuleDetailOutputType = any;
export type GetModuleLearnerV2OutputType = any;
export type GetModulesOutputType = any;
export type GetMyAssessmentResultOutputType = any;
export type GetMyBenefitsOutputType = any;
export type GetMyCustomerReviewsOutputType = any;
export type GetMyJourneyOutputType = any;
export type GetMyKeysOutputType = any;
export type GetMyPoliciesOutputType = any;
export type GetMyRewardsOutputType = any;
export type GetMyToolsDataOutputType = any;
export type GetMyTrainingRequestsOutputType = any;
export type GetMyUniformsOutputType = any;
export type GetNotificationsOutputType = any;
export type GetOnboardingDataOutputType = any;
export type GetOnboardingJourneysOutputType = any;
export type GetOnboardingQueueOutputType = any;
export type GetPermissionMatrixOutputType = any;
export type GetPersonalTasksOutputType = any;
export type GetPlandayShiftsOutputType = any;
export type GetPoliciesOutputType = any;
export type GetPolicyDetailOutputType = any;
export type GetPolicyReportOutputType = any;
export type GetProfileOutputType = any;
export type GetPubInfoOutputType = any;
export type GetQuizHistoryOutputType = any;
export type GetRecognitionDataOutputType = any;
export type GetRefresherScheduleOutputType = any;
export type GetReportsCentreInputType = any;
export type GetReportsCentreOutputType = any;
export type GetRetryQueueOutputType = any;
export type GetReviewsOutputType = any;
export type GetRoomLayoutsOutputType = any;
export type GetSharedDocumentsOutputType = any;
export type GetShiftsPageOutputType = any;
export type GetSopsOutputType = any;
export type GetStaffDashboardOutputType = any;
export type GetStaffHomeV2OutputType = any;
export type GetStaffReadinessStatusOutputType = any;
export type GetSystemsDataOutputType = any;
export type GetTablePlannerDataOutputType = any;
export type GetTeamReadinessOutputType = any;
export type GetTrainingAdminCategoriesOutputType = any;
export type GetTrainingAdminCourseDetailOutputType = any;
export type GetTrainingAdminCoursesOutputType = any;
export type GetTrainingAdminDashboardOutputType = any;
export type GetTrainingAdminPoliciesOutputType = any;
export type GetTrainingAnalyticsOutputType = any;
export type GetTrainingBuilderDataOutputType = any;
export type GetTrainingHomeOutputType = any;
export type GetTrainingRenewalsOutputType = any;
export type GetTrainingVideoLibraryOutputType = any;
export type GetUsersOutputType = any;
export type GetXeroAdminOutputType = any;
export type GetXeroPayLeaveOutputType = any;
export type GetXeroPayslipsOutputType = any;
export type PreviewTipJarInviteOutputType = any;
export type ProcessUploadOutputType = any;
export type SubmitCourseQuizOutputType = any;
export type SubmitKnowledgeCheckOutputType = any;
export type SubmitQuizOutputType = any;
export type SubmitSafeAndLegalQuizOutputType = any;
export type UploadTrainingDocumentOutputType = any;
export const acknowledgeAnnouncement = (input: any = {}) => callEndpoint('acknowledgeAnnouncement', input);
export const acknowledgeDocument = (input: any = {}) => callEndpoint('acknowledgeDocument', input);
export const acknowledgePolicy = (input: any = {}) => callEndpoint('acknowledgePolicy', input);
export const acknowledgePolicyVersion = (input: any = {}) => callEndpoint('acknowledgePolicyVersion', input);
export const adminEnrollEmployee = (input: any = {}) => callEndpoint('adminEnrollEmployee', input);
export const aiRoomLayout = (input: any = {}) => callEndpoint('aiRoomLayout', input);
export const applyMutation = (input: any = {}) => callEndpoint('applyMutation', input);
export const askHandbookQuestion = (input: any) => streamEndpoint('askHandbookQuestion', input);
export const askPolicyQuestion = (input: any) => streamEndpoint('askPolicyQuestion', input);
export const assignComplianceForm = (input: any = {}) => callEndpoint('assignComplianceForm', input);
export const assignPolicy = (input: any = {}) => callEndpoint('assignPolicy', input);
export const bulkImportQA = (input: any = {}) => callEndpoint('bulkImportQA', input);
export const bulkUpdateImports = (input: any = {}) => callEndpoint('bulkUpdateImports', input);
export const bulkUpdateScheduledJobs = (input: any = {}) => callEndpoint('bulkUpdateScheduledJobs', input);
export const chatAssistant = (input: any) => streamEndpoint('chatAssistant', input);
export const checkAgeEstimates = (input: any = {}) => callEndpoint('checkAgeEstimates', input);
export const checkLeaveConflicts = (input: any = {}) => callEndpoint('checkLeaveConflicts', input);
export const claimQuizPoints = (input: any = {}) => callEndpoint('claimQuizPoints', input);
export const completeAssessment = (input: any = {}) => callEndpoint('completeAssessment', input);
export const completeChecklist = (input: any = {}) => callEndpoint('completeChecklist', input);
export const completeTask = (input: any = {}) => callEndpoint('completeTask', input);
export const convertFeedbackToAction = (input: any = {}) => callEndpoint('convertFeedbackToAction', input);
export const createContentFromImport = (input: any = {}) => callEndpoint('createContentFromImport', input);
export const deleteAnnouncement = (input: any = {}) => callEndpoint('deleteAnnouncement', input);
export const deleteCategory = (input: any = {}) => callEndpoint('deleteCategory', input);
export const deleteCoshhSubstance = (input: any = {}) => callEndpoint('deleteCoshhSubstance', input);
export const deleteCourseModule = (input: any = {}) => callEndpoint('deleteCourseModule', input);
export const deleteCustomerContact = (input: any = {}) => callEndpoint('deleteCustomerContact', input);
export const deleteDocument = (input: any = {}) => callEndpoint('deleteDocument', input);
export const deleteEvent = (input: any = {}) => callEndpoint('deleteEvent', input);
export const deleteExternalCert = (input: any = {}) => callEndpoint('deleteExternalCert', input);
export const deleteFireSafetyItem = (input: any = {}) => callEndpoint('deleteFireSafetyItem', input);
export const deleteHandbookSection = (input: any = {}) => callEndpoint('deleteHandbookSection', input);
export const deleteJournalEntry = (input: any = {}) => callEndpoint('deleteJournalEntry', input);
export const deleteKnowledgeBase = (input: any = {}) => callEndpoint('deleteKnowledgeBase', input);
export const deleteMaintenanceTask = (input: any = {}) => callEndpoint('deleteMaintenanceTask', input);
export const deleteModule = (input: any = {}) => callEndpoint('deleteModule', input);
export const deletePersonalTask = (input: any = {}) => callEndpoint('deletePersonalTask', input);
export const deletePolicy = (input: any = {}) => callEndpoint('deletePolicy', input);
export const deleteQAItem = (input: any = {}) => callEndpoint('deleteQAItem', input);
export const deleteRoom = (input: any = {}) => callEndpoint('deleteRoom', input);
export const deleteToolItem = (input: any = {}) => callEndpoint('deleteToolItem', input);
export const deleteVenueTable = (input: any = {}) => callEndpoint('deleteVenueTable', input);
export const emailFloorPlan = (input: any = {}) => callEndpoint('emailFloorPlan', input);
export const emailHandbookSection = (input: any = {}) => callEndpoint('emailHandbookSection', input);
export const emailScheduledJobsReport = (input: any = {}) => callEndpoint('emailScheduledJobsReport', input);
export const enhanceHandbookSections = (input: any = {}) => callEndpoint('enhanceHandbookSections', input);
export const exportSafeSummary = (input: any = {}) => callEndpoint('exportSafeSummary', input);
export const exportScheduledJobs = (input: any = {}) => callEndpoint('exportScheduledJobs', input);
export const extractDocumentText = (input: any = {}) => callEndpoint('extractDocumentText', input);
export const generateComplianceQuiz = (input: any = {}) => callEndpoint('generateComplianceQuiz', input);
export const generateCsvReport = (input: any = {}) => callEndpoint('generateCsvReport', input);
export const generateMiniQuiz = (input: any = {}) => callEndpoint('generateMiniQuiz', input);
export const generateQuizQuestions = (input: any = {}) => callEndpoint('generateQuizQuestions', input);
export const generateSafeAndLegalQuiz = (input: any = {}) => callEndpoint('generateSafeAndLegalQuiz', input);
export const generateTrainingCertificate = (input: any = {}) => callEndpoint('generateTrainingCertificate', input);
export const getAdminAttensi = (input: any = {}) => callEndpoint('getAdminAttensi', input);
export const getAdminComplianceForms = (input: any = {}) => callEndpoint('getAdminComplianceForms', input);
export const getAdminCoursePreview = (input: any = {}) => callEndpoint('getAdminCoursePreview', input);
export const getAdminDashboard = (input: any = {}) => callEndpoint('getAdminDashboard', input);
export const getAdminEditRequests = (input: any = {}) => callEndpoint('getAdminEditRequests', input);
export const getAdminEmployeeProgress = (input: any = {}) => callEndpoint('getAdminEmployeeProgress', input);
export const getAdminEmployees = (input: any = {}) => callEndpoint('getAdminEmployees', input);
export const getAdminEnrollments = (input: any = {}) => callEndpoint('getAdminEnrollments', input);
export const getAdminHandbook = (input: any = {}) => callEndpoint('getAdminHandbook', input);
export const getAdminModules = (input: any = {}) => callEndpoint('getAdminModules', input);
export const getAdminPolicies = (input: any = {}) => callEndpoint('getAdminPolicies', input);
export const getAdminQuestions = (input: any = {}) => callEndpoint('getAdminQuestions', input);
export const getAdminReports = (input: any = {}) => callEndpoint('getAdminReports', input);
export const getAdminRewardsData = (input: any = {}) => callEndpoint('getAdminRewardsData', input);
export const getAdminTrainingRequests = (input: any = {}) => callEndpoint('getAdminTrainingRequests', input);
export const getAdminUniforms = (input: any = {}) => callEndpoint('getAdminUniforms', input);
export const getAdminVenueData = (input: any = {}) => callEndpoint('getAdminVenueData', input);
export const getAnnouncements = (input: any = {}) => callEndpoint('getAnnouncements', input);
export const getAssessmentQueue = (input: any = {}) => callEndpoint('getAssessmentQueue', input);
export const getAssessmentSession = (input: any = {}) => callEndpoint('getAssessmentSession', input);
export const getAssessorPinStatus = (input: any = {}) => callEndpoint('getAssessorPinStatus', input);
export const getAuditReadiness = (input: any = {}) => callEndpoint('getAuditReadiness', input);
export const getAvailability = (input: any = {}) => callEndpoint('getAvailability', input);
export const getBackupData = (input: any = {}) => callEndpoint('getBackupData', input);
export const getBmsEvents = (input: any = {}) => callEndpoint('getBmsEvents', input);
export const getBridgeFeedAudit = (input: any = {}) => callEndpoint('getBridgeFeedAudit', input);
export const getBridgeHealth = (input: any = {}) => callEndpoint('getBridgeHealth', input);
export const getCertificates = (input: any = {}) => callEndpoint('getCertificates', input);
export const getChecklistTemplates = (input: any = {}) => callEndpoint('getChecklistTemplates', input);
export const getComplianceCerts = (input: any = {}) => callEndpoint('getComplianceCerts', input);
export const getComplianceData = (input: any = {}) => callEndpoint('getComplianceData', input);
export const getComplianceExpiry = (input: any = {}) => callEndpoint('getComplianceExpiry', input);
export const getComplianceQuiz = (input: any = {}) => callEndpoint('getComplianceQuiz', input);
export const getCoshhData = (input: any = {}) => callEndpoint('getCoshhData', input);
export const getCourseBuilderModules = (input: any = {}) => callEndpoint('getCourseBuilderModules', input);
export const getCourseCompletion = (input: any = {}) => callEndpoint('getCourseCompletion', input);
export const getCourseDetail = (input: any = {}) => callEndpoint('getCourseDetail', input);
export const getCourseModuleDetail = (input: any = {}) => callEndpoint('getCourseModuleDetail', input);
export const getCourseQuizQuestions = (input: any = {}) => callEndpoint('getCourseQuizQuestions', input);
export const getCustomerContacts = (input: any = {}) => callEndpoint('getCustomerContacts', input);
export const getDailyOpsBridge = (input: any = {}) => callEndpoint('getDailyOpsBridge', input);
export const getDataQuality = (input: any = {}) => callEndpoint('getDataQuality', input);
export const getDocumentAccessLogs = (input: any = {}) => callEndpoint('getDocumentAccessLogs', input);
export const getDocumentLibrary = (input: any = {}) => callEndpoint('getDocumentLibrary', input);
export const getDocuments = (input: any = {}) => callEndpoint('getDocuments', input);
export const getDuplicateStaff = (input: any = {}) => callEndpoint('getDuplicateStaff', input);
export const getEmployeeOfMonth = (input: any = {}) => callEndpoint('getEmployeeOfMonth', input);
export const getEngagementInsights = (input: any = {}) => callEndpoint('getEngagementInsights', input);
export const getEvents = (input: any = {}) => callEndpoint('getEvents', input);
export const getFeatureToggles = (input: any = {}) => callEndpoint('getFeatureToggles', input);
export const getFeedbackCentre = (input: any = {}) => callEndpoint('getFeedbackCentre', input);
export const getFireLog = (input: any = {}) => callEndpoint('getFireLog', input);
export const getHandbook = (input: any = {}) => callEndpoint('getHandbook', input);
export const getHandoverDocument = (input: any = {}) => callEndpoint('getHandoverDocument', input);
export const getHealthSafetyData = (input: any = {}) => callEndpoint('getHealthSafetyData', input);
export const getImportQueue = (input: any = {}) => callEndpoint('getImportQueue', input);
export const getImportReport = (input: any = {}) => callEndpoint('getImportReport', input);
export const getInfoHub = (input: any = {}) => callEndpoint('getInfoHub', input);
export const getJournal = (input: any = {}) => callEndpoint('getJournal', input);
export const getKeyManagement = (input: any = {}) => callEndpoint('getKeyManagement', input);
export const getKnowledgeBase = (input: any = {}) => callEndpoint('getKnowledgeBase', input);
export const getLabourOverview = (input: any = {}) => callEndpoint('getLabourOverview', input);
export const getLeaveRequests = (input: any = {}) => callEndpoint('getLeaveRequests', input);
export const getMaintenanceTasks = (input: any = {}) => callEndpoint('getMaintenanceTasks', input);
export const getManagerDashboard = (input: any = {}) => callEndpoint('getManagerDashboard', input);
export const getManagerOps = (input: any = {}) => callEndpoint('getManagerOps', input);
export const getManagerReviews = (input: any = {}) => callEndpoint('getManagerReviews', input);
export const getManagerTasks = (input: any = {}) => callEndpoint('getManagerTasks', input);
export const getManagerTriage = (input: any = {}) => callEndpoint('getManagerTriage', input);
export const getMessages = (input: any = {}) => callEndpoint('getMessages', input);
export const getModuleDetail = (input: any = {}) => callEndpoint('getModuleDetail', input);
export const getModuleLearnerV2 = (input: any = {}) => callEndpoint('getModuleLearnerV2', input);
export const getModules = (input: any = {}) => callEndpoint('getModules', input);
export const getMyAssessmentResult = (input: any = {}) => callEndpoint('getMyAssessmentResult', input);
export const getMyBenefits = (input: any = {}) => callEndpoint('getMyBenefits', input);
export const getMyCustomerReviews = (input: any = {}) => callEndpoint('getMyCustomerReviews', input);
export const getMyJourney = (input: any = {}) => callEndpoint('getMyJourney', input);
export const getMyKeys = (input: any = {}) => callEndpoint('getMyKeys', input);
export const getMyPolicies = (input: any = {}) => callEndpoint('getMyPolicies', input);
export const getMyRewards = (input: any = {}) => callEndpoint('getMyRewards', input);
export const getMyToolsData = (input: any = {}) => callEndpoint('getMyToolsData', input);
export const getMyTrainingRequests = (input: any = {}) => callEndpoint('getMyTrainingRequests', input);
export const getMyUniforms = (input: any = {}) => callEndpoint('getMyUniforms', input);
export const getNotifications = (input: any = {}) => callEndpoint('getNotifications', input);
export const getOnboardingData = (input: any = {}) => callEndpoint('getOnboardingData', input);
export const getOnboardingJourneys = (input: any = {}) => callEndpoint('getOnboardingJourneys', input);
export const getOnboardingQueue = (input: any = {}) => callEndpoint('getOnboardingQueue', input);
export const getPermissionMatrix = (input: any = {}) => callEndpoint('getPermissionMatrix', input);
export const getPersonalTasks = (input: any = {}) => callEndpoint('getPersonalTasks', input);
export const getPlandayShifts = (input: any = {}) => callEndpoint('getPlandayShifts', input);
export const getPolicies = (input: any = {}) => callEndpoint('getPolicies', input);
export const getPolicyDetail = (input: any = {}) => callEndpoint('getPolicyDetail', input);
export const getPolicyReport = (input: any = {}) => callEndpoint('getPolicyReport', input);
export const getProfile = (input: any = {}) => callEndpoint('getProfile', input);
export const getPubInfo = (input: any = {}) => callEndpoint('getPubInfo', input);
export const getQuizHistory = (input: any = {}) => callEndpoint('getQuizHistory', input);
export const getRecognitionData = (input: any = {}) => callEndpoint('getRecognitionData', input);
export const getRefresherSchedule = (input: any = {}) => callEndpoint('getRefresherSchedule', input);
export const getReportsCentre = (input: any = {}) => callEndpoint('getReportsCentre', input);
export const getRetryQueue = (input: any = {}) => callEndpoint('getRetryQueue', input);
export const getReviews = (input: any = {}) => callEndpoint('getReviews', input);
export const getRoomLayouts = (input: any = {}) => callEndpoint('getRoomLayouts', input);
export const getSharedDocuments = (input: any = {}) => callEndpoint('getSharedDocuments', input);
export const getShiftsPage = (input: any = {}) => callEndpoint('getShiftsPage', input);
export const getSops = (input: any = {}) => callEndpoint('getSops', input);
export const getStaffDashboard = (input: any = {}) => callEndpoint('getStaffDashboard', input);
export const getStaffHomeV2 = (input: any = {}) => callEndpoint('getStaffHomeV2', input);
export const getStaffReadinessStatus = (input: any = {}) => callEndpoint('getStaffReadinessStatus', input);
export const getSystemsData = (input: any = {}) => callEndpoint('getSystemsData', input);
export const getTablePlannerData = (input: any = {}) => callEndpoint('getTablePlannerData', input);
export const getTeamReadiness = (input: any = {}) => callEndpoint('getTeamReadiness', input);
export const getTrainingAdminCategories = (input: any = {}) => callEndpoint('getTrainingAdminCategories', input);
export const getTrainingAdminCourseDetail = (input: any = {}) => callEndpoint('getTrainingAdminCourseDetail', input);
export const getTrainingAdminCourses = (input: any = {}) => callEndpoint('getTrainingAdminCourses', input);
export const getTrainingAdminDashboard = (input: any = {}) => callEndpoint('getTrainingAdminDashboard', input);
export const getTrainingAdminPolicies = (input: any = {}) => callEndpoint('getTrainingAdminPolicies', input);
export const getTrainingAnalytics = (input: any = {}) => callEndpoint('getTrainingAnalytics', input);
export const getTrainingBuilderData = (input: any = {}) => callEndpoint('getTrainingBuilderData', input);
export const getTrainingHome = (input: any = {}) => callEndpoint('getTrainingHome', input);
export const getTrainingRenewals = (input: any = {}) => callEndpoint('getTrainingRenewals', input);
export const getTrainingVideoLibrary = (input: any = {}) => callEndpoint('getTrainingVideoLibrary', input);
export const getUsers = (input: any = {}) => callEndpoint('getUsers', input);
export const getXeroAdmin = (input: any = {}) => callEndpoint('getXeroAdmin', input);
export const getXeroPayLeave = (input: any = {}) => callEndpoint('getXeroPayLeave', input);
export const getXeroPayslips = (input: any = {}) => callEndpoint('getXeroPayslips', input);
export const importPolicies = (input: any = {}) => callEndpoint('importPolicies', input);
export const markNotificationsRead = (input: any = {}) => callEndpoint('markNotificationsRead', input);
export const markReplyRead = (input: any = {}) => callEndpoint('markReplyRead', input);
export const pauseAssessment = (input: any = {}) => callEndpoint('pauseAssessment', input);
export const previewTipJarInvite = (input: any = {}) => callEndpoint('previewTipJarInvite', input);
export const processEditRequest = (input: any = {}) => callEndpoint('processEditRequest', input);
export const processLeaveRequest = (input: any = {}) => callEndpoint('processLeaveRequest', input);
export const processRedemption = (input: any = {}) => callEndpoint('processRedemption', input);
export const processSignoff = (input: any = {}) => callEndpoint('processSignoff', input);
export const processTrainingRequest = (input: any = {}) => callEndpoint('processTrainingRequest', input);
export const processUpload = (input: any = {}) => callEndpoint('processUpload', input);
export const publishPolicy = (input: any = {}) => callEndpoint('publishPolicy', input);
export const publishStaffReadinessSnapshot = (input: any = {}) => callEndpoint('publishStaffReadinessSnapshot', input);
export const redeemReward = (input: any = {}) => callEndpoint('redeemReward', input);
export const reportKeyLost = (input: any = {}) => callEndpoint('reportKeyLost', input);
export const requestAssessment = (input: any = {}) => callEndpoint('requestAssessment', input);
export const requestReassessment = (input: any = {}) => callEndpoint('requestReassessment', input);
export const requestUniform = (input: any = {}) => callEndpoint('requestUniform', input);
export const resolveDuplicate = (input: any = {}) => callEndpoint('resolveDuplicate', input);
export const resumeAssessment = (input: any = {}) => callEndpoint('resumeAssessment', input);
export const retryQueueAction = (input: any = {}) => callEndpoint('retryQueueAction', input);
export const saveAnnouncement = (input: any = {}) => callEndpoint('saveAnnouncement', input);
export const saveAssessmentEvidence = (input: any = {}) => callEndpoint('saveAssessmentEvidence', input);
export const saveAssessmentScore = (input: any = {}) => callEndpoint('saveAssessmentScore', input);
export const saveAttensiCourse = (input: any = {}) => callEndpoint('saveAttensiCourse', input);
export const saveAvailability = (input: any = {}) => callEndpoint('saveAvailability', input);
export const saveCategory = (input: any = {}) => callEndpoint('saveCategory', input);
export const saveChecklistTemplate = (input: any = {}) => callEndpoint('saveChecklistTemplate', input);
export const saveComplianceCert = (input: any = {}) => callEndpoint('saveComplianceCert', input);
export const saveComplianceForm = (input: any = {}) => callEndpoint('saveComplianceForm', input);
export const saveComplianceProgress = (input: any = {}) => callEndpoint('saveComplianceProgress', input);
export const saveCoshhSubstance = (input: any = {}) => callEndpoint('saveCoshhSubstance', input);
export const saveCourseModule = (input: any = {}) => callEndpoint('saveCourseModule', input);
export const saveCustomerContact = (input: any = {}) => callEndpoint('saveCustomerContact', input);
export const saveDocument = (input: any = {}) => callEndpoint('saveDocument', input);
export const saveEvent = (input: any = {}) => callEndpoint('saveEvent', input);
export const saveEventSetup = (input: any = {}) => callEndpoint('saveEventSetup', input);
export const saveExternalCert = (input: any = {}) => callEndpoint('saveExternalCert', input);
export const saveFeatureToggle = (input: any = {}) => callEndpoint('saveFeatureToggle', input);
export const saveFeedback = (input: any = {}) => callEndpoint('saveFeedback', input);
export const saveFireLog = (input: any = {}) => callEndpoint('saveFireLog', input);
export const saveFireSafetyItem = (input: any = {}) => callEndpoint('saveFireSafetyItem', input);
export const saveGpCalculation = (input: any = {}) => callEndpoint('saveGpCalculation', input);
export const saveHandbookSection = (input: any = {}) => callEndpoint('saveHandbookSection', input);
export const saveJournalEntry = (input: any = {}) => callEndpoint('saveJournalEntry', input);
export const saveJournalNote = (input: any = {}) => callEndpoint('saveJournalNote', input);
export const saveKeyAssignment = (input: any = {}) => callEndpoint('saveKeyAssignment', input);
export const saveKeyType = (input: any = {}) => callEndpoint('saveKeyType', input);
export const saveLearningPath = (input: any = {}) => callEndpoint('saveLearningPath', input);
export const saveLeaveRequest = (input: any = {}) => callEndpoint('saveLeaveRequest', input);
export const saveMaintenanceTask = (input: any = {}) => callEndpoint('saveMaintenanceTask', input);
export const saveManagerTask = (input: any = {}) => callEndpoint('saveManagerTask', input);
export const saveModule = (input: any = {}) => callEndpoint('saveModule', input);
export const saveModuleContent = (input: any = {}) => callEndpoint('saveModuleContent', input);
export const saveModuleProgress = (input: any = {}) => callEndpoint('saveModuleProgress', input);
export const saveModuleVideo = (input: any = {}) => callEndpoint('saveModuleVideo', input);
export const saveOnboardingJourney = (input: any = {}) => callEndpoint('saveOnboardingJourney', input);
export const saveOnboardingStep = (input: any = {}) => callEndpoint('saveOnboardingStep', input);
export const savePersonalTask = (input: any = {}) => callEndpoint('savePersonalTask', input);
export const savePolicy = (input: any = {}) => callEndpoint('savePolicy', input);
export const savePolicyAdmin = (input: any = {}) => callEndpoint('savePolicyAdmin', input);
export const savePubInfo = (input: any = {}) => callEndpoint('savePubInfo', input);
export const saveQAItem = (input: any = {}) => callEndpoint('saveQAItem', input);
export const saveQuestion = (input: any = {}) => callEndpoint('saveQuestion', input);
export const saveRecognition = (input: any = {}) => callEndpoint('saveRecognition', input);
export const saveRewardItem = (input: any = {}) => callEndpoint('saveRewardItem', input);
export const saveRoom = (input: any = {}) => callEndpoint('saveRoom', input);
export const saveRoomFixtures = (input: any = {}) => callEndpoint('saveRoomFixtures', input);
export const saveRoomLayout = (input: any = {}) => callEndpoint('saveRoomLayout', input);
export const saveShiftPrep = (input: any = {}) => callEndpoint('saveShiftPrep', input);
export const saveSignature = (input: any = {}) => callEndpoint('saveSignature', input);
export const saveTablePositions = (input: any = {}) => callEndpoint('saveTablePositions', input);
export const saveTrainingCategory = (input: any = {}) => callEndpoint('saveTrainingCategory', input);
export const saveTrainingCourse = (input: any = {}) => callEndpoint('saveTrainingCourse', input);
export const saveVenueTable = (input: any = {}) => callEndpoint('saveVenueTable', input);
export const scheduleReview = (input: any = {}) => callEndpoint('scheduleReview', input);
export const seedKnowledgeBase = (input: any = {}) => callEndpoint('seedKnowledgeBase', input);
export const sendEmployeeSms = (input: any = {}) => callEndpoint('sendEmployeeSms', input);
export const sendJournalToManager = (input: any = {}) => callEndpoint('sendJournalToManager', input);
export const sendMessage = (input: any = {}) => callEndpoint('sendMessage', input);
export const sendTipJarInvite = (input: any = {}) => callEndpoint('sendTipJarInvite', input);
export const setAssessorPin = (input: any = {}) => callEndpoint('setAssessorPin', input);
export const setDefaultLayout = (input: any = {}) => callEndpoint('setDefaultLayout', input);
export const signDeclaration = (input: any = {}) => callEndpoint('signDeclaration', input);
export const splitHandbookContent = (input: any = {}) => callEndpoint('splitHandbookContent', input);
export const splitHandbookPdf = (input: any = {}) => callEndpoint('splitHandbookPdf', input);
export const splitHandbookWord = (input: any = {}) => callEndpoint('splitHandbookWord', input);
export const submitBarnHire = (input: any = {}) => callEndpoint('submitBarnHire', input);
export const submitComplianceQuiz = (input: any = {}) => callEndpoint('submitComplianceQuiz', input);
export const submitCourseQuiz = (input: any = {}) => callEndpoint('submitCourseQuiz', input);
export const submitCustomerReview = (input: any = {}) => callEndpoint('submitCustomerReview', input);
export const submitEditRequest = (input: any = {}) => callEndpoint('submitEditRequest', input);
export const submitKnowledgeCheck = (input: any = {}) => callEndpoint('submitKnowledgeCheck', input);
export const submitMiniQuiz = (input: any = {}) => callEndpoint('submitMiniQuiz', input);
export const submitQuiz = (input: any = {}) => callEndpoint('submitQuiz', input);
export const submitSafeAndLegalQuiz = (input: any = {}) => callEndpoint('submitSafeAndLegalQuiz', input);
export const submitSuggestion = (input: any = {}) => callEndpoint('submitSuggestion', input);
export const submitTrainingRequest = (input: any = {}) => callEndpoint('submitTrainingRequest', input);
export const trackHandbookProgress = (input: any = {}) => callEndpoint('trackHandbookProgress', input);
export const transcribeVoiceNote = (input: any = {}) => callEndpoint('transcribeVoiceNote', input);
export const updateAdminChecklist = (input: any = {}) => callEndpoint('updateAdminChecklist', input);
export const updateEmployee = (input: any = {}) => callEndpoint('updateEmployee', input);
export const updateImportItem = (input: any = {}) => callEndpoint('updateImportItem', input);
export const updateProgress = (input: any = {}) => callEndpoint('updateProgress', input);
export const updateReview = (input: any = {}) => callEndpoint('updateReview', input);
export const updateUniformRequest = (input: any = {}) => callEndpoint('updateUniformRequest', input);
export const updateUser = (input: any = {}) => callEndpoint('updateUser', input);
export const uploadTrainingCertificate = (input: any = {}) => callEndpoint('uploadTrainingCertificate', input);
export const uploadTrainingDocument = (input: any = {}) => callEndpoint('uploadTrainingDocument', input);
export const validateDevToken = (input: any = {}) => callEndpoint('validateDevToken', input);
export const xeroConfirmMapping = (input: any = {}) => callEndpoint('xeroConfirmMapping', input);
export const xeroDisconnect = (input: any = {}) => callEndpoint('xeroDisconnect', input);
export const xeroOAuthStart = (input: any = {}) => callEndpoint('xeroOAuthStart', input);
export const xeroSuggestMappings = (input: any = {}) => callEndpoint('xeroSuggestMappings', input);
